/**
 * Роли пользователей
 * @module Constants/roles
 * */

/**
 * @constant {String} - ROLE_ADMIN
 * */
export const ROLE_ADMIN = 'admin'
/**
 * @constant {String} - ROLE_GUEST
 * */
export const ROLE_GUEST = 'guest'

export default {
  ROLE_ADMIN,
  ROLE_GUEST
}
